import clsx from 'clsx'

export interface Step {
  id: string
  label: string
  value?: string
  placeholder: string
}

interface StepNavigatorProps {
  steps: Step[]
  currentStepIndex: number
  onStepClick?: (stepIndex: number) => void
}

export function StepNavigator ({ steps, currentStepIndex, onStepClick }: StepNavigatorProps) {
  return (
    <div className='flex items-center bg-gray-200 rounded-xl overflow-hidden border border-gray-200'>
      {steps.map((step, index) => {
        const isActive = index <= currentStepIndex
        const isCurrentStep = index === currentStepIndex
        const isClickable = onStepClick && index !== currentStepIndex
        const isLast = index === steps.length - 1

        return (
          <div key={step.id} className='flex flex-1 items-center'>
            <button
              type='button'
              onClick={() => isClickable && onStepClick(index)}
              disabled={!isClickable}
              className={clsx(
                'flex-1 flex flex-col gap-1 px-4 py-2 text-left rounded-xl',
                isCurrentStep && 'bg-white border border-thatch-400',
                !isCurrentStep && 'bg-transparent',
                isClickable && 'hover:bg-gray-100 cursor-pointer',
                !isClickable && 'cursor-default'
              )}
            >
              <span
                className={clsx(
                  'body-sm',
                  isActive ? 'text-gray-500' : 'text-gray-800'
                )}
              >
                {step.label}
              </span>
              <span
                className={clsx(
                  'body',
                  isActive ? 'text-gray-800' : 'text-gray-500'
                )}
              >
                {isActive && step.value ? step.value : step.placeholder}
              </span>
            </button>
            {!isLast && (
              <div className='h-6 w-px bg-gray-400 shrink-0' />
            )}
          </div>
        )
      })}
    </div>
  )
}
